import { CATEGORY_LIST_KEYS } from '../../../constants';
import { EMPTY_CATEGORY } from 'store/categorySlice';
import { addPrimaryCategory, addSecondaryCategory, addThirdLevelCategory, setIsOpened } from 'store/categorySlice';

export const handleCategoryChange = (
  listKey,
  srId,
  value,
  dispatch,
  primaryCategory,
  secondaryCategory,
  thirdLevelCategory,
) => {
  const id = srId?.toString();

  switch (listKey) {
    case CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY:
      if (!primaryCategory) {
        dispatch(addPrimaryCategory({ id, value }));
      }
      break;

    case CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY:
      if (!secondaryCategory) {
        dispatch(addSecondaryCategory({ id, value }));
      }
      break;

    case CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY:
      if (!thirdLevelCategory) {
        dispatch(addThirdLevelCategory({ id, value }));
      }
      break;
    default:
      break;
  }
};

export const clearCategoryValue = (listKey, id, dispatch, handleUpdateSR) => {
  switch (listKey) {
    case CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY:
      dispatch(addPrimaryCategory({ id, value: EMPTY_CATEGORY }));
      handleUpdateSR({});
      break;

    case CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY:
      dispatch(addSecondaryCategory({ id, value: EMPTY_CATEGORY }));
      break;

    case CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY:
      dispatch(addThirdLevelCategory({ id, value: EMPTY_CATEGORY }));
      break;

    default:
      return;
  }
};
